import script from "./ShowDatatableCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowDatatableCard.vue?vue&type=script&setup=true&lang=js"

import "./ShowDatatableCard.vue?vue&type=style&index=0&id=6e769739&scoped=true&lang=css"
import "./ShowDatatableCard.vue?vue&type=style&index=1&id=6e769739&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e769739"]])

export default __exports__